import { useState } from "react";
import { Mail, Facebook } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import Reveal from "@/components/Reveal";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", form);
      toast.success("Thank you — we'll be in touch soon.");
      setForm({ name: "", email: "", message: "" });
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div data-testid="contact-page">
      <PageHeader overline="Say Hello" title="Contact" subtitle="Questions, collaborations, or just want to say hi? We'd love to hear from you." />
      <section className="py-24 bg-mahogany-900">
        <div className="max-w-5xl mx-auto px-6 grid lg:grid-cols-5 gap-14">
          <Reveal className="lg:col-span-2">
            <h2 className="font-serif text-3xl text-cream mb-6">Let's Stay Connected</h2>
            <a href="mailto:jabrena@joinmahogany.com" className="flex items-center gap-3 text-cream/80 hover:text-gold mb-8"><Mail size={18} className="text-gold" /> jabrena@joinmahogany.com</a>
            <p className="text-cream/60 text-sm mb-4 uppercase tracking-wider">Follow along</p>
            <div className="flex gap-3">
              <a href="https://www.facebook.com/people/The-Mahogany-Room-A-Literary-Society-for-Black-Women/61593363442767/" target="_blank" rel="noreferrer" className="w-11 h-11 rounded-full border border-gold/30 flex items-center justify-center text-gold hover:bg-gold hover:text-mahogany-900 transition-colors" data-testid="contact-social-facebook"><Facebook size={18} strokeWidth={1.5} /></a>
            </div>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-3">
            <form onSubmit={submit} className="bg-mahogany-950 gold-frame rounded-sm p-8 space-y-6" data-testid="contact-form">
              <input required placeholder="Your Name" value={form.name} onChange={set("name")} className="input-line" data-testid="contact-name" />
              <input required type="email" placeholder="Email Address" value={form.email} onChange={set("email")} className="input-line" data-testid="contact-email" />
              <textarea required rows={5} placeholder="Your Message" value={form.message} onChange={set("message")} className="input-line resize-none" data-testid="contact-message" />
              <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="contact-submit">{busy ? "Sending..." : "Send Message"}</button>
            </form>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
